export default __webpack_public_path__ + "static/media/lunar-calendar.54dd7919.png";